import HomePage from '@/pages/HomePage.vue';
import NotFound from '@/pages/NotFound.vue';
import TestComponent from '@/pages/TEST-COMPONENT/TestComponent.vue';
import alhondiga from './router/alhondiga';
import commercialisationRoutes from './router/commercialisation';
import presenceRoutes from './router/presence';
import productionRoutes from './router/production';
import repairsRoutes from './router/repairs';
import reportsRoutes from './router/reports';
import settingsRoutes from './router/settings';
import warehouseRoutes from './router/warehouse';

const routes = [
  {
    path: '/',
    component: HomePage,
    meta: {
      useNewStyles: true,
    },
  },
  {
    path: '/testComponent',
    component: TestComponent,
  },

  ...alhondiga,
  ...commercialisationRoutes,
  ...presenceRoutes,
  ...productionRoutes,
  ...repairsRoutes,
  ...reportsRoutes,
  ...settingsRoutes,
  ...warehouseRoutes,

  {
    path: '(.*)',
    component: NotFound,
    meta: {
      useNewStyles: true,
    },
  },
];

export default routes;
